import { ALIGN_TYPES, VALUE_TYPES as THVT } from "../../../configs/TableHeaderConstants";
import * as Yup from 'yup';
import VALUE_TYPES from '../../../configs/ValueTypeConstants';

export const DiscountState = {
    type: null,
    school_id: null,
    student_id: null,
    from_date: null,
    end_date: null,
    discount_percentage: null,
    remarks: null
};

export const DiscountSchema = Yup.object().shape({
    type: Yup.string().required(),
    school_id: Yup.number().required(),
    student_id: Yup.number().required(),
    from_date: Yup.date().required(),
    end_date: Yup.date().required(),
    discount_percentage: Yup.number().required().min(0).max(100),
    remarks: Yup.string().nullable()
});

export const DiscountFormFields = [
    { name: "type", title: "Type", required: true, type: VALUE_TYPES.SELECT, options: [{ id: "Special Discount" }], apiRequired: true, displayKey: "id", itemValue: "id" },
    { name: "school_id", title: "School", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "student_id", title: "Student", required: true, type: VALUE_TYPES.AUTOCOMPLETE, options: [], apiRequired: true, displayKey: "code_name", itemValue: "id" },
    { name: "from_date", title: "From Date", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "id", itemValue: "id" },
    { name: "end_date", title: "End Date", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "id", itemValue: "id" },
    { name: "discount_percentage", title: "Discount %", required: true, type: VALUE_TYPES.NUMBER },
    { name: "remarks", title: "Remarks", required: false, type: VALUE_TYPES.TEXTAREA },
];

export const DISCOUNT_LINE_TABLE_HEADS = [
    { id: 'invoice_no', label: 'Invoice No', align: ALIGN_TYPES.ALIGN_LEFT, type: THVT.TEXT },
    { id: 'invoice_date', label: 'Invoice Date', align: ALIGN_TYPES.ALIGN_LEFT, type: THVT.DATE },
    { id: 'student_code', label: 'Student Code', align: ALIGN_TYPES.ALIGN_LEFT, type: THVT.TEXT },
    { id: 'class', label: 'Class', align: ALIGN_TYPES.ALIGN_RIGHT, type: THVT.TEXT },
    { id: 'division', label: 'Division', align: ALIGN_TYPES.ALIGN_LEFT, type: THVT.TEXT },
    { id: 'due_date', label: 'Due Date', align: ALIGN_TYPES.ALIGN_LEFT, type: THVT.DATE },
    { id: 'status', label: 'Status', align: ALIGN_TYPES.ALIGN_LEFT, type: THVT.TEXT },
    { id: 'total_amount', label: 'Total Amount', align: ALIGN_TYPES.ALIGN_RIGHT, type: THVT.NUMBER },
    { id: 'remarks', label: 'Remarks', align: ALIGN_TYPES.ALIGN_RIGHT, type: THVT.TEXT },
]


const filterState = {
    schools: null,
    students: null,
    class: null,
    division: null,
    status: null,
};

const filterSchema = Yup.object().shape({
    schools: Yup.array().nullable(),
    students: Yup.array().nullable(),
    class: Yup.string().nullable(),
    division: Yup.string().nullable(),
    status: Yup.string().nullable(),
});

const filterFormFields: any[] = [
    { name: "schools", title: "Schools", required: false, type: VALUE_TYPES.MULTISELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "students", title: "Students", required: false, type: VALUE_TYPES.MULTISELECT, options: [], apiRequired: true, displayKey: "code_name", itemValue: "id" },
    { name: "class", title: "Class", required: false, type: VALUE_TYPES.TEXT },
    { name: "division", title: "Division", required: false, type: VALUE_TYPES.TEXT },
    { name: "status", title: "Status", required: false, type: VALUE_TYPES.SELECT, options: [{ name: "Active" }, { name: "In-Active" }], apiRequired: true, displayKey: "name", itemValue: "name" },
];

export const filter = {
    state: filterState,
    schema: filterSchema,
    formFields: filterFormFields
}

